/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Record_string_number_ } from './Record_string_number_';
/**
 * The MarketComparableResponse object is used to retrieve similar markets to a given market.
 */
export type MarketComparableResponse = {
    /**
     * The census tract's 11-digits fips code [Definition here](https://www.census.gov/programs-surveys/geography/guidance/geo-identifiers.html)
     */
    fips_code: string;
    /**
     * The similarity score between the subject and the comparable market. The score ranges from 0 to 1.
     */
    similarity: number;
    /**
     * The centroid of the census tract. The first element is the latitude, and the second element is the longitude.
     */
    centroid: {
        lon: number;
        lat: number;
    };
    /**
     * The geometry of the census tract. The type is always "Polygon".
     */
    geometry: {
        coordinates: Array<Array<Array<number>>>;
        type: MarketComparableResponse.type;
    };
    /**
     * Some valuable demographic information about the census tract.
     */
    demographics: Record_string_number_;
};
export namespace MarketComparableResponse {
    export enum type {
        POLYGON = 'Polygon',
    }
}

